import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  Image,
  Loader,
  Card,
  Dimmer,
  Icon,
  Button,
  Container,
  Popup
} from 'semantic-ui-react';

import {
  getFileType,
  getFilename,
  getFileSize,
  getFilenameWithoutExtension
} from './Utils/asset.utils';

import modes from './constants/modes';

class UploaderAssetPreview extends PureComponent {
  constructor(props) {
    super(props);

    const allowedImageTypes = ['png', 'jpg', 'jpeg', 'gif'];

    const { selectedFile } = props; // refer onFileRead() in UploaderPanel.jsx for object structure.
    const { file } = selectedFile;
    const { type: filetype } = file;

    const splitted = filetype.split('/');
    const extension = `${splitted.slice(-1)}`;

    this.state = {
      ...selectedFile,
      shouldPreviewUpdate: true,
      isImage: allowedImageTypes.indexOf(extension) !== -1
    };
  }

  componentWillReceiveProps(nextProps) {
    const { uploadStatus, selectedFile } = nextProps;

    switch (uploadStatus) {
      case modes.UPLOADER_PANEL.PENDING:
        break;
      case modes.UPLOADER_PANEL.UPLOADING:
        break;
      case modes.UPLOADER_PANEL.COMPLETED:
        this.setState((prevState) => ({
          ...prevState,
          ...selectedFile
        }));
        break;

      default:
        break;
    }
  }

  componentDidUpdate() {
    const { status } = this.props;

    switch (status) {
      case modes.UPLOADER_PANEL.UPLOADING:
        this.startUploading();
        break;

      default:
        break;
    }
  }

  startUploading = () => {
    const {
      markUploadedFile,
      selectedFile,
      uploadFile,
      assetLibraryAccountId,
      fbToken,
      user,
      selectedTagOptions,
      fbWorker
    } = this.props;

    // flatten tag ids
    const tagIds = Object.keys(selectedTagOptions)
      .map((key) => selectedTagOptions[key])
      .flat()
      .map((option) => ({
        id: option.key
      }));

    const { file } = selectedFile;

    uploadFile(
      file,
      assetLibraryAccountId,
      tagIds,
      fbToken,
      user,
      fbWorker
    ).then((response) => {
      const { statusCode, result, workerInProgress } = response;
      const { asset } = result || {};
      const { key, status } = selectedFile;
      const { name, size, type } = file;

      const processedFile = {
        key,
        status,
        file: {
          name,
          size,
          type
        },
        asset,
        workerInProgress: workerInProgress || false // workerInProgress will be undefined if the asset is image
      };

      markUploadedFile(
        processedFile,
        statusCode === 200 ? modes.ASSET_FILE.COMPLETED : modes.ASSET_FILE.ERROR
      );
    });
  };

  onRemoveAssetButtonClick = () => {
    const { removeSelectedAsset } = this.props;
    const { key } = this.state;

    if (removeSelectedAsset) removeSelectedAsset(key);
  };

  render() {
    const { file, dataUrl, isImage } = this.state;
    const { status, uploadStatus } = this.props;
    const { name: filename } = file || {};

    const hasLongAssetName = filename && filename.length > 15;

    return (
      <Card fluid style={{ marginBottom: '0.5em' }}>
        {!dataUrl && (
          <Image src="./../../../assets/images/placeholder-image.jpg" />
        )}

        {isImage && dataUrl ? (
          <Image src={dataUrl} style={{ width: '100%', height: '15em' }} />
        ) : (
          <video
            src={dataUrl}
            type="video/mp4"
            controls
            muted
            style={{ width: '100%', height: '15em' }}
          >
            <track kind="captions" />
          </video>
        )}

        <Card.Content>
          {hasLongAssetName ? (
            <Popup
              content={getFilenameWithoutExtension(filename)}
              trigger={<Card.Header>{getFilename({ filename })}</Card.Header>}
            />
          ) : (
            <Card.Header>{getFilename({ filename })}</Card.Header>
          )}
          <Card.Meta>
            {`${getFileSize({ file })}, ${getFileType({ file })}`}
          </Card.Meta>
        </Card.Content>
        {uploadStatus === modes.UPLOADER_PANEL.UPLOADING &&
        (status === modes.ASSET_FILE.UPLOAD_PENDING ||
          status === modes.ASSET_FILE.UPLOADING) ? (
            <Dimmer active>
              <Loader indeterminate>Uploading...</Loader>
            </Dimmer>
        ) : null}

        <Card.Content extra>
          {status === modes.ASSET_FILE.UPLOAD_PENDING && (
            <Container>
              <Icon name="circle" size="small" color="grey" />
              pending...
              <Button
                basic
                icon
                floated="right"
                size="mini"
                onClick={this.onRemoveAssetButtonClick}
              >
                <Icon name="trash alternate outline" />
              </Button>
            </Container>
          )}

          {status === modes.ASSET_FILE.COMPLETED && (
            <Container>
              <Icon name="circle" size="small" color="green" />
              completed...
            </Container>
          )}

          {status === modes.ASSET_FILE.ERROR && (
            <Container>
              <Icon name="circle" size="small" color="red" />
              error...
            </Container>
          )}
        </Card.Content>
      </Card>
    );
  }
}

UploaderAssetPreview.propTypes = {
  selectedFile: PropTypes.shape({
    key: PropTypes.string.isRequired,
    dataUrl: PropTypes.string.isRequired,
    file: PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  fbToken: PropTypes.string.isRequired,
  removeSelectedAsset: PropTypes.func.isRequired,
  markUploadedFile: PropTypes.func.isRequired,
  selectedTagOptions: PropTypes.object.isRequired
};
export default UploaderAssetPreview;



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/UploaderAssetPreview.jsx